import React from 'react';
import Animated, { Extrapolation, interpolate, useAnimatedStyle } from 'react-native-reanimated';
import { connect } from 'react-redux';
import { HStack, Text, VStack } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
import { ActionBarHeader } from './ActionBarHeader';
const mapStateToProps = ({ scrollPage }) => {
    return {
        scrollPage,
    };
};
const connector = connect(mapStateToProps);
const LogoActionBar = ({ testID, scrollPage, title }) => {
    const logoAnimatedStyles = useAnimatedStyle(() => {
        if (!scrollPage.isActive || !title) {
            return {
                opacity: 1,
            };
        }
        const opacity = interpolate(scrollPage.scrollValue, [0, 20], [1, 0], Extrapolation.CLAMP);
        return {
            opacity,
        };
    }, [scrollPage.scrollValue, scrollPage.isActive, title]);
    const titleAnimatedStyles = useAnimatedStyle(() => {
        if (!scrollPage.isActive) {
            return {
                opacity: 0,
            };
        }
        const opacity = interpolate(scrollPage.scrollValue, [0, 20], [0, 1], Extrapolation.CLAMP);
        return {
            opacity,
        };
    }, [scrollPage.scrollValue, scrollPage.isActive]);
    return (React.createElement(VStack, { style: {
            top: 0,
            left: 0,
            right: 0,
            position: 'absolute',
            zIndex: 2,
        }, backgroundColor: "$surface.container" },
        React.createElement(ActionBarHeader, { testID: testID }),
        React.createElement(HStack, { padding: "$4", justifyContent: "center", alignItems: "center", testID: `${testID}-libreLogo` },
            React.createElement(Animated.View, { style: logoAnimatedStyles },
                React.createElement("img", { src: i18n.t('Global.microcopy.common.libreLogoLight'), alt: "" })),
            title && (React.createElement(Animated.View, { style: [{ position: 'absolute', zIndex: 1 }, titleAnimatedStyles] },
                React.createElement(Text, { testID: `${testID}.action-title`, color: "$text.100", fontSize: "$h4.strong", fontWeight: "$h4.strong" }, title))))));
};
const ConnectedLogoActionBar = connector(LogoActionBar);
export { ConnectedLogoActionBar as LogoActionBar };
